/* src/app/order/pages/order-decline/order-decline.component.scss */
/*# sourceMappingURL=order-decline.component.css.map */
